export const data = [
  {
    author: "some dude",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
    id: "000001",
    images: [],
    ranking: 3,
    title: "Sample Book 01"
  },
  {
    author: "Jane Doe",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
    id: "000002",
    images: [],
    ranking: 4.5,
    title: "Sample Book 02"
  },
  {
    author: "some dude",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
    id: "000003",
    images: [],
    ranking: 3,
    title: "Sample Book 03"
  },
  {
    author: "Jane Doe",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr.",
    id: "000004",
    images: [],
    ranking: 4.5,
    title: "Sample Book 04"
  },
  {
    author: "some dude",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
    id: "000001",
    images: [],
    ranking: 3,
    title: "Sample Book 01"
  },
  {
    author: "Jane Doe",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
    id: "000002",
    images: [],
    ranking: 4.5,
    title: "Sample Book 02"
  },
  {
    author: "some dude",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
    id: "000003",
    images: [],
    ranking: 3,
    title: "Sample Book 03"
  },
  {
    author: "Jane Doe",
    description: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr.",
    id: "000004",
    images: [],
    ranking: 4.5,
    title: "Sample Book 04"
  }
];



// WEBPACK FOOTER //
// ./src/components/data/readinglist.js